import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getClients } from "../api";
import { DocListTab, SalesDocPage } from "./SalesDocShared";

export default function BillingNotesPage() {
  const { data: clients = [] } = useQuery({ queryKey: ["clients"], queryFn: getClients });

  return (
    <SalesDocPage
      title="Billing Notes"
      subtitle="Convert to Tax Invoice or Receipt"
      typeColor="#1d4ed8"
    >
      <DocListTab
        docType="billing_note"
        clients={clients}
        convertOptions={[
          { label: "Tax Invoice", target: "tax_invoice", color: "#c2410c" },
          { label: "Receipt",     target: "receipt",     color: "#166534" },
        ]}
      />
    </SalesDocPage>
  );
}
